"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clickBG = {
    clickBG: {
        width: '100vw',
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        opacity: 0.6,
        zIndex: -1,
    }
};
